import { useState, FormEvent, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Button, TextField, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { supabase } from '../utils/supabase';

export default function Auth() {
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [rememberMe, setRememberMe] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [logoUrl, setLogoUrl] = useState<string>('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchLogoUrl = async () => {
            const { data } = await supabase.storage.from('image').getPublicUrl('brand_logo.png');
            setLogoUrl(data.publicUrl);
        };

        fetchLogoUrl();
    }, []);

    async function handleSignIn(e: FormEvent) {
        e.preventDefault();
        const { error } = await supabase.auth.signInWithPassword({
            email,
            password,
        });
        if (error) {
            setError(error.message);
        } else {
            navigate('/camera');
        }
    }

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh', // Occupies full vertical height
                p: 2, // Optional padding
            }}
        >
            <Paper sx={{ maxWidth: 400, mx: 'auto', mt: 4, p: 2 }} square={false} elevation={4}>
                {logoUrl && (
                    <img
                        src={logoUrl}
                        alt="Logo"
                        style={{ width: '100%', height: 'auto', marginBottom: '16px' }} // Adjust styles as needed
                    />
                )}
                <Typography variant="h5">Login</Typography>
                <form onSubmit={handleSignIn}>
                    <TextField
                        label="Email"
                        fullWidth
                        margin="normal"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <TextField
                        label="Password"
                        type="password"
                        fullWidth
                        margin="normal"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <FormControlLabel
                        control={<Checkbox checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />}
                        label="Remember Me"
                    />
                    {error && <Typography color="error">{error}</Typography>}
                    <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
                        Sign In
                    </Button>
                </form>
            </Paper>
        </Box>
    );
}